import axiosInstance from './axios-config';
import appConfig from 'config/config';

import { _get, _post } from './service-util';
import * as query from 'qs';

import {
  FILE_UPLOAD_PAGES,
  VPN,
  DEDICATED_INTERNET,
  FEASIBILITY,
  ADDRESS_RESOLUTION,
  BULK_UPGRADE_ACTIONS,
  CART,
  CREATED,
  LOCATIONS_SAVED,
  MULTI_SITE_MODULE_ID,
  SUMMARY_AUTH_TOKEN,
  AUTH_TOKEN
} from 'home/view/manage-feasibility/constants';

import { AUTHORIZATION_HEADER, MODULE_ID, PNQ_AUTHORIZATION_HEADER, SELECTED_PARTY_ACCOUNT, SUMMARY_AUTHORIZATION_HEADER } from 'home/common/constants/constants';
import { findParamFromUrl, getFromSessionStorage } from 'common/utils/app.utils';
import { isUserTypeIsKAM } from 'dedicated/components/plan-and-configuration/configure-plan-pricing-constant';
import axios from 'common/interceptor/app.interceptor';
import environment from 'config/config';

import { TYPEOF_ORDER, getProductType, isBulkUpgrade, isPreOrder } from 'common/constants/app.constants';

const PRODUCT_NAME = 'productName';

const getServiceType = (isDedicatedJourney) => {
  return isDedicatedJourney ? (getFromSessionStorage(MODULE_ID, PRODUCT_NAME) ? getFromSessionStorage(MODULE_ID, PRODUCT_NAME) : DEDICATED_INTERNET) : VPN;
};

const isApiSuccess = (res) => res && res.status && res.status === 200;

export const getAccessTokenForDev = () => {
  axiosInstance.defaults.baseURL = appConfig.profileUnauthBaseUrl;
  let APIEndpoint = `user/v2/authenticate`;

  let config = {
    headers: {
      'iv-user': 'test@gmail.com',
      requestSrc: 'server',
      'z-auth-key': 'zuul'
    }
  };

  let reqData = {
    emailId: '',
    password: ''
  };

  if (isUserTypeIsKAM()) {
    axiosInstance.defaults.baseURL = 'http://10.5.74.79:8022/b2b-iam/';
    APIEndpoint = `v3/login`;
    config = {
      headers: {
        'app-id': 'SELFCARE',
        'Content-Type': 'application/json'
      }
    };

    reqData = {
      emailId: '',
      password: '',
      grantType: 'PASSWORD'
    };
  }

  return axiosInstance
    .post(APIEndpoint, reqData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const createLead = (reqData = {}, isdedicatedJourney) => {
  axiosInstance.defaults.baseURL = appConfig.apiBaseUrl;

  reqData['sendToCbft'] = true;

  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney)
    },
    headers: {
      'iv-user': 'test@gmail.com'
    }
  };

  return axiosInstance
    .post(`lead/create`, reqData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cancelLead = (reqData = {}, leadAuthToken, isdedicatedJourney) => {
  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney)
    },
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _post(`lead/cancel`, reqData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cancelCart = (reqData = {}, leadAuthToken, isdedicatedJourney) => {
  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney)
    },
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _post(`cart/cancel`, reqData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const updateLead = (reqData = {}, isdedicatedJourney, leadAuthToken) => {
  reqData['sendToCbft'] = true;

  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney)
    },
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _post(`lead/update`, reqData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const sampleDownload = (isdedicatedJourney, downloadInvalidCircuits = false, actionName = null, source = '') => {
  const getActionType = () => {
    if (isBulkUpgrade()) {
      if (downloadInvalidCircuits) {
        return BULK_UPGRADE_ACTIONS.INVALID_CIRCUIT_INVENTORY;
      }

      return BULK_UPGRADE_ACTIONS.SAMPLE_CIRCUIT_INVENTORY;
    }

    return actionName ?? ADDRESS_RESOLUTION;
  };

  const getBaseUri = () => {
    if (isBulkUpgrade() || actionName) {
      return 'lead/bulkDownload/locations';
    }

    return `lead/download/sampleBulkUpload/ua`;
  };

  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney),
      action: getActionType(),
      source
    },
    responseType: 'blob'
  };

  if (isBulkUpgrade() || actionName) {
    config['headers'] = {
      Authorization: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
    };
  }

  return _get(getBaseUri(), config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export const downloadUpgradeEmptyTemplate = (isdedicatedJourney) => {
  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney),
      action: BULK_UPGRADE_ACTIONS.SAMPLE_CIRCUIT_INVENTORY
    },
    headers: {
      Authorization: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
    },
    responseType: 'blob'
  };

  return _get(`lead/download/sampleBulkUpload/ua`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const feasibilityReportDownload = (isdedicatedJourney, leadId, leadAuthToken) => {
  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney),
      action: FEASIBILITY,
      leadId
    },
    headers: {
      Authorization: leadAuthToken
    },
    responseType: 'blob'
  };

  return _get(`lead/bulkDownload/locations`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const retry4gFeasibility = (leadId, leadAuthToken) => {
  const config = {
    params: {
      addressIds: []
    },
    headers: {
      Authorization: leadAuthToken,
      leadId,
      serviceType: getServiceType(true)
    }
  };

  return _post(`lead/bulkFeasibility/retry`, {}, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkUploadAddressResolution = (formData, leadAuthToken, onUploadProgress, step, abortSignal) => {
  let config = {
    headers: {
      Authorization: leadAuthToken
    },
    abortSignal
  };

  if (onUploadProgress !== null || onUploadProgress !== undefined) {
    config = { ...config, onUploadProgress };
  }

  const setFormDataAction = () => {
    if (isBulkUpgrade()) {
      if (step === FILE_UPLOAD_PAGES.SAMPLE_DOWNLOAD) {
        formData.append('action', BULK_UPGRADE_ACTIONS.SAMPLE_CIRCUIT_INVENTORY);
      }

      if (step === FILE_UPLOAD_PAGES.ADDRESS_RESOLUTION) {
        formData.append('action', BULK_UPGRADE_ACTIONS.CONFIGURE_CIRCUIT_INVENTORY);
      }
    } else {
      formData.append('action', ADDRESS_RESOLUTION);
    }
  };

  // UPDATING PAYLOAD FORM DATA ACTIONS
  setFormDataAction();

  return _post(`lead/bulkUpload/locations`, formData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkUploadCart = (formData, leadAuthToken, cartId, onUploadProgress) => {
  const config = {
    headers: {
      Authorization: leadAuthToken
    },
    onUploadProgress
  };

  formData.append('action', CART);
  formData.append('cartId', cartId);

  return _post(`lead/bulkUpload/locations`, formData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const downloadErrorSheet = (errorSheetUrl, leadAuthToken, leadId) => {
  const config = {
    headers: {
      Authorization: leadAuthToken
      // leadId,
    },
    responseType: 'blob'
  };

  return _get(`document/download?documentUrl=${errorSheetUrl}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchLocationDetails = (leadAuthToken, page, size, extraParams) => {
  const queryParams = {
    page,
    size,
    ...extraParams
  };

  const config = {
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _get(`lead/fetch/lineItems/v2?${query.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkDownloadAddressResolution = (leadAuthToken) => {
  const getActions = () => {
    if (isBulkUpgrade()) {
      return BULK_UPGRADE_ACTIONS.CONFIGURE_CIRCUIT_INVENTORY;
    }

    return ADDRESS_RESOLUTION;
  };

  const config = {
    params: {
      action: getActions()
    },
    headers: {
      Authorization: leadAuthToken
    },
    responseType: 'blob'
  };

  return _get(`lead/bulkDownload/locations`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkDownloadCart = (leadAuthToken, isdedicatedJourney, cartId) => {
  const config = {
    params: {
      serviceType: getServiceType(isdedicatedJourney),
      action: CART,
      cartId
    },
    headers: {
      Authorization: leadAuthToken
    },
    responseType: 'blob'
  };

  return _get(`lead/bulkDownload/locations`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkFeasibilityCheck = (leadAuthToken) => {
  const config = {
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _post(`lead/bulkFeasibility/check`, {}, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const upgradeFetchCircuitDetails = (circuitId, isKyc = false) => {
  const queryParams = {
    circuitId
  };

  const getAuthToken = () => {
    if (isUserTypeIsKAM()) {
      axiosInstance.defaults.baseURL = environment.pnqapiBaseUrl;
      return getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
    }

    if (isKyc) {
      const summaryToken = getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER) || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      return summaryToken;
    }

    return getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
  };

  const config = {
    headers: {
      Authorization: getAuthToken()
    }
  };

  const urlPart = isKyc ? 'order' : 'lead';

  return axiosInstance
    .get(`${urlPart}/fetch/circuitDetails?${query.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cartSearch = (leadAuthToken, addParams = true, params = { params: `${CREATED},${LOCATIONS_SAVED}` }) => {
  const config = {
    params: addParams ? params : null,
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _get(`cart/search`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const cartCheckout = (leadAuthToken, reqBody) => {
  const config = {
    headers: {
      Authorization: leadAuthToken
    }
  };

  return _post(`cart/checkout`, reqBody, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getOrders = (params, config) => {
  return _get(`orders/search?${query.stringify(params)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const createOrder = (leadAuthToken, cartId, isdedicatedJourney, checkIfPreOrder = () => {}, source = '') => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const reqBody = {
    leadAuthorizationToken: leadAuthToken,
    serviceType: getServiceType(isdedicatedJourney),
    orderSource: source ? source : 'ONLINE_ACQ',
    cartId
  };

  if (isBulkUpgrade()) {
    reqBody['orderType'] = isPreOrder() || checkIfPreOrder() ? 'PRE_ORDER' : 'CHANGE_ORDER';
    reqBody['journeyType'] = 'MULTI_SITE';
    reqBody['orderSubType'] = 'UPGRADE';
  } else if (isPreOrder() || checkIfPreOrder()) {
    reqBody['orderType'] = 'PRE_ORDER';
    reqBody['orderSubType'] = TYPEOF_ORDER.NEW;
  }

  return axiosInstance
    .post(`order/create`, reqBody)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchOrder = (orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    headers: {
      Authorization: orderAuthToken
    }
  };

  return axiosInstance
    .get(`order/fetch`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchKycConfig = () => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const params = {
    serviceType: getProductType()
  };

  return axiosInstance
    .get(`config/client/fetch?password=${params.password}&serviceType=${params.serviceType}`, {})
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchOrderDetails = (orderAuthToken, page, size, extraParams) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const queryParams = {
    page,
    size,
    ...extraParams
  };

  const config = {
    headers: {
      Authorization: orderAuthToken
    }
  };

  return axiosInstance
    .get(`order/fetch/lineItems?${query.stringify(queryParams)}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const orderBulkDownload = (orderId, orderAuthToken, isdedicatedJourney) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const queryParams = {};

  const config = {
    params: {
      action: 'ORDER_LINE_ITEMS'
    },
    headers: {
      // orderId,
      // serviceType: getServiceType(isdedicatedJourney),
      Authorization: orderAuthToken
    },
    responseType: 'blob'
  };

  return axiosInstance
    .get(`order/bulk/download`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const siteReadinessBulkDownload = (orderId, orderAuthToken, isdedicatedJourney) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const queryParams = {};

  const config = {
    params: {
      action: 'APPOINTMENT_LINE_ITEMS'
    },
    headers: {
      // orderId,
      // serviceType: getServiceType(isdedicatedJourney),
      Authorization: orderAuthToken
    },
    responseType: 'blob'
  };

  return axiosInstance
    .get(`order/bulk/download`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const orderBulkUpload = (formData, orderAuthToken, onUploadProgress) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: {
      action: 'ORDER_LINE_ITEMS'
    },
    headers: {
      Authorization: orderAuthToken
    },
    onUploadProgress
  };

  // formData.append("action", ADDRESS_RESOLUTION);

  return axiosInstance
    .post(`order/bulk/upload`, formData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const siteReadinessBulkUpload = (formData, orderAuthToken, onUploadProgress) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: {
      action: 'APPOINTMENT_LINE_ITEMS'
    },
    headers: {
      Authorization: orderAuthToken
    },
    onUploadProgress
  };

  // formData.append("action", ADDRESS_RESOLUTION);

  return axiosInstance
    .post(`order/bulk/upload`, formData, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const downloadSummaryErrorSheet = (errorSheetUrl, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    headers: {
      Authorization: orderAuthToken
    },
    responseType: 'blob'
  };

  return axiosInstance
    .get(`document/download?documentUrl=${errorSheetUrl}`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const submitOrderForSummary = (orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    headers: {
      Authorization: orderAuthToken
    }
  };

  return axiosInstance
    .post(`order/submit`, {}, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const updateOrderForSummary = (payload, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    headers: {
      Authorization: orderAuthToken
    }
  };

  return axiosInstance
    .post(`order/update`, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const uploadDocumentsForSummary = (payload, orderAuthToken, onUploadProgress) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    headers: {
      Authorization: orderAuthToken
    },
    onUploadProgress
  };

  return axiosInstance
    .post(`order/documents/upload`, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const deleteDocumentsForSummary = (payload, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: payload,
    headers: {
      Authorization: orderAuthToken
    },
    responseType: 'arraybuffer'
  };

  return axiosInstance
    .delete(`order/documents/delete`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const getUploadedDocumentsForSummary = (payload, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: payload,
    headers: {
      Authorization: orderAuthToken
    },
    responseType: 'arraybuffer'
  };

  return axiosInstance
    .get(`order/documents/fetch`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const generateSummaryAuthToken = (aehAccessToken = '', orderId = '', partyId = '') => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const payload = {
    aehAccessToken,
    orderId,
    partyId
  };

  return axiosInstance
    .post(`login/aeh`, payload)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const generateToken = (payload, isKyc = false) => {
  if (isKyc) {
    axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;
  } else {
    axiosInstance.defaults.baseURL = appConfig.apiBaseUrl;
  }

  return axiosInstance
    .post(`login/aeh`, payload)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const downloadOrderExcel = (lineItemUrl, authorization_token, isKyc = false) => {
  if (isKyc) {
    axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;
  } else {
    axiosInstance.defaults.baseURL = appConfig.apiBaseUrl;
  }
  const config = {
    params: {
      documentUrl: lineItemUrl
    },
    headers: {
      Authorization: authorization_token
    }
  };
  return axiosInstance
    .get(`document/download`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetch_BA_Accounts_MultiSite = (partyId, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: { partyId, billableOnly: false, product: getProductType() },
    headers: {
      Authorization: orderAuthToken,
      'Content-Type': 'application/json'
    }
  };

  return axiosInstance
    .get(`customer/accounts`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const fetchAccountDetailsByAccountNumber_MultiSite = (accountNumber, orderAuthToken) => {
  axiosInstance.defaults.baseURL = appConfig.dedicatedSummaryApiUrl;

  const config = {
    params: { accountNumber, contactTypes: 'BCP,BDCP' },
    headers: {
      Authorization: orderAuthToken,
      'Content-Type': 'application/json'
    }
  };

  return axiosInstance
    .get(`customer/contactDetails`, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

/* Multi Site Configure Pricing */

export const fetchLineItemsForUser = (params) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    skipServiceType: true
  };

  return _get(`lead/fetch/lineItems/v2?${query.stringify(params)}`, config);
};

export const fetchRateCardIdList = () => {
  const params = {
    partyId: findParamFromUrl('partyId', null) || getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT),
    serviceType: getProductType()
  };

  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return _get(`plans/fetch/rateCardIds?${query.stringify(params)}`, config);
};

const downloadExcelForKAM = (configuration) => {
  return axios({
    method: 'GET',
    url: `${environment.pnqapiBaseUrl}lead/download/lineItems`,
    config: {
      ignoreError: true,
      dedicatedJourney: true,
      pnqToken: configuration.headers.Authorization
    },
    ...configuration,
    skipServiceType: true,
    withCredentials: false
  });
};

const uploadExcelForKAM = (body, configuration) => {
  return axios({
    method: 'POST',
    url: `${environment.pnqapiBaseUrl}lead/upload/lineItems`,
    data: body,
    config: {
      ignoreError: true,
      dedicatedJourney: true,
      pnqToken: configuration.headers.Authorization
    },
    ...configuration,
    skipServiceType: true,
    withCredentials: false
  });
};

export const fetchLineItemsForKam = (params) => {
  const pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
  return axios({
    method: 'GET',
    url: `${environment.pnqapiBaseUrl}lead/fetch/lineItems/v2?${query.stringify(params)}`,
    // params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: pnqToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true,
      pnqToken: pnqToken
    }
  });
};

export const getLead = (isPnQ = true) => {
  let pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
  let url = `${environment.pnqapiBaseUrl}lead/get`;

  if (!isPnQ) {
    pnqToken = getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
    url = `${environment.apiBaseUrl}lead/fetch`;
  }

  return axios({
    method: 'GET',
    url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: pnqToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true,
      pnqToken: pnqToken
    }
  });
};

export const downloadErrorSheetForKAM = (errorSheetUrl, pnqToken) => {
  return axios({
    method: 'GET',
    url: `${environment.pnqapiBaseUrl}lead/download/errorsheet?documentUrl=${errorSheetUrl}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: pnqToken
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true,
      pnqToken: pnqToken
    },
    responseType: 'blob'
  })
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const sendQoutationToUser = (request) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    skipServiceType: true
  };

  return _post(`cart/sendQuotation`, request, config);
};

const sendQuotationAOI = (request, orderAuthToken) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: orderAuthToken
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    skipServiceType: true
  };

  return _post(`plans/sendQuotation`, request, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const sendPhotoLinkAOI = (request = {}, orderAuthToken) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: orderAuthToken
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    skipServiceType: true
  };

  return _post(`image/send/link`, request, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

const bulkEditActionForUser = (request) => {
  return axios({
    method: 'post',
    url: appConfig.apiBaseUrl + 'lead/bulkEdit/sites',
    data: request,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER)
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

export const sendOTP = (payload) => {
  axiosInstance.defaults.baseURL = appConfig.apiBaseUrl;

  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axiosInstance
    .post(`otp/send`, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export const verifyOTP = (payload) => {
  axiosInstance.defaults.baseURL = appConfig.apiBaseUrl;

  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axiosInstance
    .post(`otp/verify/unAuth`, payload, config)
    .then((res) => isApiSuccess(res) && { res })
    .catch((err) => ({ err }));
};

export {
  createLead,
  updateLead,
  cancelLead,
  cancelCart,
  sampleDownload,
  feasibilityReportDownload,
  bulkUploadAddressResolution,
  downloadErrorSheet,
  fetchLocationDetails,
  bulkDownloadAddressResolution,
  bulkDownloadCart,
  bulkFeasibilityCheck,
  cartSearch,
  getOrders,
  cartCheckout,
  bulkUploadCart,
  createOrder,
  fetchOrder,
  fetchOrderDetails,
  fetchKycConfig,
  orderBulkDownload,
  orderBulkUpload,
  downloadSummaryErrorSheet,
  submitOrderForSummary,
  updateOrderForSummary,
  deleteDocumentsForSummary,
  getUploadedDocumentsForSummary,
  uploadDocumentsForSummary,
  generateSummaryAuthToken,
  downloadExcelForKAM,
  uploadExcelForKAM,
  sendQoutationToUser,
  sendQuotationAOI,
  sendPhotoLinkAOI,
  fetch_BA_Accounts_MultiSite,
  fetchAccountDetailsByAccountNumber_MultiSite,
  bulkEditActionForUser,
  upgradeFetchCircuitDetails,
  retry4gFeasibility,
  siteReadinessBulkDownload,
  siteReadinessBulkUpload,
  generateToken,
  downloadOrderExcel
};
